<template>
    <div class="mask" @touchstart.stop="">
        <Loading :size="40"></Loading>
    </div>
</template>

<style lang="less" scoped>
.mask {
    display: flex;
    align-items: center;
    justify-content: center;
}
</style>

<script>
import { Loading } from '@ks/sharp-ui';
import '@ks/sharp-ui/lib/themes/default/loading.css';

export default {
    components: {
        Loading,
    },
};
</script>


